const setTermsAndCondition = payload => ({
  type: "SET_TERMS_AND_CONDITION",
  payload
});

const setAllBanks = payload => ({
  type: "SET_ALL_BANKS",
  payload
});

const setReferralInput = payload => ({
  type: "SET_REFERRAL_INPUT",
  payload
});

const setMyReferralsInput = payload => ({
  type: "SET_MY_REFERRALS_INPUT",
  payload
});

export default {
  setTermsAndCondition,
  setReferralInput,
  setAllBanks,
  setMyReferralsInput
};
